import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  CompletedTriviaQuestion,
  GameGroupPrizeType,
  GroupType,
  LoyaltyCategoryType,
  PredictorGroupGames,
  Prize,
  ProcessedPredictorQuestion,
  QuestionStatus,
  TriviaGroupGames,
} from '@fgb/core';

@Component({
  selector: 'fgbcl-game-result',
  templateUrl: './game-result.component.html',
  styleUrl: './game-result.component.scss',
})
export class GameResultComponent {
  @Input() gameDetails: TriviaGroupGames | PredictorGroupGames;
  @Input() groupType: GroupType;
  @Input() redirectPageURL: string;
  @Input() showShareWithFriendButton: boolean = false;
  @Input() pointIcon: string = 'loyalty';
  loyaltyCategoryType = LoyaltyCategoryType.Games;
  @Input() isExternal: boolean = false;
  prize: Prize | null;
  groupTypes = GroupType;
  totalCorrectAnswer = 0;
  totalQuestions = 0;
  totalPoints = 0;
  animatedProgress = 0;
  percentage = 0;
  @Output() closeModal = new EventEmitter();

  ngOnInit(): void {
    this.totalQuestions = this.gameDetails.Questions.length;
    if (this.groupType == GroupType.Trivia) {
      let triviaDetails = this.gameDetails as TriviaGroupGames;
      if (triviaDetails.EntityGroupCompleted) {
        this.totalQuestions = triviaDetails.Questions.filter((question) => question.Status != QuestionStatus.NotStarted).length;
      }

      this.totalCorrectAnswer = this.gameDetails.Questions.map((question) => question as CompletedTriviaQuestion).filter(
        (question) => question.Status == QuestionStatus.Correct
      ).length;
      this.prize = triviaDetails.Prize;
    }

    if (this.groupType == GroupType.Predictor) {
      this.totalCorrectAnswer = this.gameDetails.Questions.map((question) => question as ProcessedPredictorQuestion).filter(
        (question) => question.IsCorrect
      ).length;
    }
    this.totalPoints = this.getTotalPointsAwarded();
    this.percentage = this.totalQuestions > 0 ? (this.totalCorrectAnswer / this.totalQuestions) * 100 : 0;
    this.animateProgress();
  }

  animateProgress(): void {
    let startValue = 0;
    const endValue = (this.totalCorrectAnswer / this.totalQuestions) * 100;
    const duration = 1000;
    const stepTime = Math.abs(Math.floor(duration / endValue));

    const timer = setInterval(() => {
      startValue++;
      this.animatedProgress = startValue;
      if (startValue >= endValue) {
        clearInterval(timer);
      }
    }, stepTime);
  }

  closeModalButton() {
    this.closeModal.emit();
  }

  getTotalPointsAwarded(): number {
    if (this.gameDetails.EntityPointsAwarded == 0) {
      let completedQuestions = this.gameDetails.Questions as CompletedTriviaQuestion[] | ProcessedPredictorQuestion[];
      let pointsFromQuestions = completedQuestions.reduce(function (a, b) {
        return a + b['PointsAwarded'];
      }, 0);

      let prize = (this.gameDetails as TriviaGroupGames | PredictorGroupGames).Prize;
      if (prize && prize.PrizeType == GameGroupPrizeType.Points && +prize.PrizeValue) {
        return +prize.PrizeValue;
      } else {
        return pointsFromQuestions;
      }
    } else {
      return this.gameDetails.EntityPointsAwarded;
    }
  }
}
